import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS } from "@/components/site/SiteHeader";

export const SiteFooter = ({ products = [] }) => (
  <footer className="site-footer">
    <div className="wrap foot">
      <div>
        <p className="foot-name">Sentinel Nexus Technologies</p>
        <p>Removing the unnecessary.<br />Advancing what matters.</p>
      </div>
      <nav aria-label="Products">
        {products.filter((p) => p.url).map((p) => (
          <a key={p.slug} href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`footer-product-${p.slug}`}>
            {p.name} <ArrowUpRight className="inline h-3 w-3" aria-hidden="true" />
          </a>
        ))}
      </nav>
      <nav aria-label="Footer">
        {NAV_LINKS.map((l) => (
          <a key={l.id} href={`#${l.id}`} data-testid={`footer-link-${l.id}`}>{l.label}</a>
        ))}
      </nav>
    </div>
    <p className="wrap foot-copy" data-testid="footer-copyright">© {new Date().getFullYear()} Sentinel Nexus Technologies</p>
  </footer>
);
